var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FFF7ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 18.3333C26.6663 22.4941 22.0505 26.8275 20.5005 28.1658C20.3561 28.2744 20.1803 28.3331 19.9997 28.3331C19.819 28.3331 19.6432 28.2744 19.4988 28.1658C17.9488 26.8275 13.333 22.4941 13.333 18.3333C13.333 16.5652 14.0354 14.8695 15.2856 13.6192C16.5359 12.369 18.2316 11.6666 19.9997 11.6666C21.7678 11.6666 23.4635 12.369 24.7137 13.6192C25.964 14.8695 26.6663 16.5652 26.6663 18.3333Z",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.8334C21.3807 20.8334 22.5 19.7141 22.5 18.3334C22.5 16.9527 21.3807 15.8334 20 15.8334C18.6193 15.8334 17.5 16.9527 17.5 18.3334C17.5 19.7141 18.6193 20.8334 20 20.8334Z",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOrange);
export default __webpack_public_path__ + "static/media/video-orange.e094bab1ef3a6262aba2bc8aa98ceaaf.svg";
export { ForwardRef as ReactComponent };